<template>
  <div class="countdown" :class="{ countdown_overlayed: $slots.default }">
    <div class="day" v-if="!typedNums || days !== '00'">
      <span class="number">{{ days }}</span>
      <span v-if="typedNums" class="number-type">д.</span>
    </div>
    <span class="countdown__divider" v-text="divider" />
    <div class="hour">
      <span class="number">{{ hours }}</span>
      <span v-if="typedNums" class="number-type">ч.</span>
    </div>
    <span class="countdown__divider" v-text="divider" />
    <div class="min">
      <span class="number">{{ minutes }}</span>
      <span v-if="typedNums" class="number-type">м.</span>
    </div>
    <span class="countdown__divider" v-text="divider" />
    <div class="sec" v-if="!typedNums || days == '00'">
      <span class="number">{{ seconds }}</span>
      <span v-if="typedNums" class="number-type">с.</span>
    </div>
    <div v-if="$slots.default" class="countdown__overlay">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    endtime: [Number, String],

    typedNums: Boolean,

    divider: {
      type: String,
      default: ":"
    }
  },
  data: function() {
    return {
      interval: null,
      diff: 0,
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    };
  },

  mounted() {
    this.startTimer();
  },

  beforeDestroy() {
    this.stopTimer();
  },

  computed: {
    formatedEndTime() {
      if (
        typeof this.endtime === "number" &&
        this.endtime.toString().length < 12
      ) {
        return this.endtime ? this.$dayjs.unix(this.endtime) : this.$dayjs();
      }

      return this.$dayjs(this.endtime);
    }
  },

  watch: {
    diff() {
      this.$nextTick(() => {
        if (this.diff <= 0) {
          this.stopTimer();
        } else {
          this.$emit("ticked", { diff: this.diff });
        }
      });
    }
  },

  methods: {
    startTimer() {
      this.handleTick();
      this.interval = setInterval(() => {
        this.handleTick();
      }, 1000);

      this.$emit("started");
    },
    stopTimer() {
      if (this.interval) clearInterval(this.interval);
      this.$emit("stoped");
    },
    formatNumber(n) {
      n = String(n > 0 ? n : 0);

      return n.length < 2 ? "0" + n : n;
    },

    handleTick() {
      let now = this.$dayjs(),
        diffDays = this.formatedEndTime.diff(now, "days"),
        diffHours = this.formatedEndTime.diff(now, "hours"),
        diffMin = this.formatedEndTime.diff(now, "minutes"),
        diff = this.formatedEndTime.diff(now, "seconds");

      this.days = this.formatNumber(diffDays);
      this.hours = this.formatNumber(diffHours % 24);
      this.minutes = this.formatNumber(diffMin % 60);
      this.seconds = this.formatNumber(this.diff % 60);
      this.diff = diff;
    }
  }
};
</script>

<style lang="scss">
.countdown {
  // width: 100%;
  position: relative;
  text-align: center;
  display: inline-flex;
  align-items: center;

  font-weight: 800;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 0.02em;

  &__overlay {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    background: rgba(0, 10, 37, 0.5);
    border-radius: 6px;

    > * {
      flex: 1 1 100%;
    }
  }

  &__divider {
    padding: 0 8px;

    .countdown_overlayed & {
      opacity: 0;
    }
  }

  .day,
  .hour,
  .min,
  .sec {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 1 auto;
    background: rgba(0, 10, 37, 0.5);
    border-radius: 6px;
    min-height: 40px;
    padding: 0px 8px;
  }

  &_overlayed {
    .day,
    .hour,
    .min,
    .sec {
      opacity: 0;
    }
  }

  .number {
    overflow: hidden;
    display: inline-flex;
    align-items: center;
  }
}
</style>
